import { View } from "@amzn/stencil-react-components/layout";
import styled from "@emotion/styled";
import React, { FC } from "react";
import { useImageFallback } from "@/common/hooks/use-image-fallback.hook";

const NO_IMAGE_PLACEHOLDER = "/img/no_logo_image.png";

const ThumbnailImage = styled.img<{ imageInset: number }>(({ imageInset }) => ({
  width: "100%",
  height: "100%",
  objectFit: "contain",
  padding: imageInset,
  boxSizing: "border-box",
}));

export interface DeviceThumbnailProps {
  imageSrc: string;
  altText: string;
  /** Square edge length in px. Figma device rows use 48. */
  size?: number;
  /** Space in px between the frame and the image, shrinking the image inside the same frame. */
  imageInset?: number;
  dataTestId?: string;
}

export const DeviceThumbnail: FC<DeviceThumbnailProps> = ({
  imageSrc,
  altText,
  size = 48,
  imageInset = 0,
  dataTestId = "device-thumbnail",
}) => {
  const image = useImageFallback(imageSrc, NO_IMAGE_PLACEHOLDER);

  return (
    <View
      width={size}
      height={size}
      flex="0 0 auto"
      border="1px solid var(--st-dt-color-neutral-20)"
      borderRadius="var(--st-dt-dimensions-border-radius-100)"
      overflow="hidden"
    >
      <ThumbnailImage
        src={image.src}
        onError={image.onError}
        alt={altText}
        data-testid={dataTestId}
        imageInset={imageInset}
      />
    </View>
  );
};
